enum TaskTypeEnum {
  equipmentReading = 'task_equipment_temp_reading',
  productReadingDelivery = 'task_product_temp_reading_delivery',
  productReadingService = 'task_product_temp_reading_service',
  cleaning = 'task_cleaning_plan',
}

export default TaskTypeEnum;
